import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-dropdown',
  templateUrl: './loan-dropdown.component.html',
  styleUrl: './loan-dropdown.component.scss',
  standalone: false
})
export class LoanDropdownComponent implements OnInit {
  @Input({ required: true }) text: string = '';
  @Input() addText?: string;
  @Input() useAdd: boolean = false;
  @Input() onAddClick?: () => void;
  @Input() startCollapsed: boolean = false;
  @Input() innerAdd?: boolean = false;
  @Input() questionText: string = "";

  collapsed: boolean = false;

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }

  ngOnInit(): void {
    this.collapsed = this.startCollapsed;
  }
}
